import type { SyntheticEvent } from "react";

import { translate } from "app/filters/i18nFilter";
import { ALERTS_BUTTON_DATA_AUTOMATION } from "app/pages/activation/components/AlertsIndication/dataAutomationKeys";
import { NEW_ALERTS } from "app/pages/activation/components/AlertsIndication/texts";
import { activationTracking } from "app/pages/activation/services/tracking";
import { useAlertsPageNavigation } from "app/pages/activation-alerts/hooks/useAlertsPageNavigation";

import * as SC from "./styles";

type AlertsIndicationSchema = {
    hasNewAlerts: boolean;
    activationId: string;
    country: number;
};

export const AlertsIndication = ({ hasNewAlerts, activationId, country }: AlertsIndicationSchema) => {
    const tracking = activationTracking.homepage;
    const { navigateToAlerts } = useAlertsPageNavigation();

    const onClick = async (event: SyntheticEvent<HTMLButtonElement>) => {
        event.stopPropagation();

        tracking.trackClickAlerts();

        await navigateToAlerts({ key: activationId, country });
    };

    return (
        <SC.AlertIndicationContainer>
            {hasNewAlerts ? (
                <SC.AlertsButton
                    iconName="radio-on"
                    onClick={onClick}
                    dataAutomation={ALERTS_BUTTON_DATA_AUTOMATION}
                >
                    {translate(NEW_ALERTS)}
                </SC.AlertsButton>
            ) : null}
        </SC.AlertIndicationContainer>
    );
};
